import { NAVIGATION_BADGE_NO_BADGE } from './constants';

const genericHeaderItem = { sc_o: 'navigation_header' };

const headerTrackings = {
  header: genericHeaderItem,
  notification_center: {
    sc_o: 'navigation_notification_center',
    sc_o_PropActionOrigin: [
      'navigation_badge_notifications',
      NAVIGATION_BADGE_NO_BADGE,
    ],
  },
  burger: {
    open: {
      PropTrackAction: 'navigation_drawer_open',
    },
  },
  premiumUpsellHeader: genericHeaderItem,
  proJobsUpsellHeader: genericHeaderItem,
};

export { headerTrackings };
